import markAvatar from './images/avatar-mark-webber.webp';
import angelaAvatar from './images/avatar-angela-gray.webp';
import jacobAvatar from './images/avatar-jacob-thompson.webp';
import rizkyaAvatar from './images/avatar-rizky-hasanuddin.webp';
import kimberlyAvatar from './images/avatar-kimberly-smith.webp';
import nathanAvatar from './images/avatar-nathan-peterson.webp';
import annaAvatar from './images/avatar-anna-kim.webp';
import chessImage from './images/image-chess.webp';

export default [
    {
         profilePhoto: markAvatar,
         name: 'Mark Webber',
         action: 'reacted to your recent post',
         isActionJoinLeftGroup: false,
         isActionReactToPost: true,
         isActionSentMessage: false,
         isActionReactToImage: false,
         groupName: '',
         postTitle: 'My first tournament today!',
         time: '1m ago',
         imageReactionThumbnail:"",
         messageDetails: '',
         notificationRead: false,
     },
    {
         profilePhoto: angelaAvatar,
         name: 'Angela Gray',
         action: 'followed you',
         isActionJoinLeftGroup: false,
         isActionReactToPost: false,
         isActionSentMessage: false,
         isActionReactToImage: false,
         groupName: '',
         postTitle: '',
         time: '5m ago',
         imageReactionThumbnail:"",
         messageDetails: '',
         notificationRead: false,
     },
    {
         profilePhoto: jacobAvatar,
         name: 'Jacob Thompson ',
         action: 'has joined your group',
         isActionJoinLeftGroup: true,
         isActionReactToPost: false,
         isActionSentMessage: false,
         isActionReactToImage: false,
         groupName: 'Chess Club',
         postTitle: '',
         time: '1 day ago',
         imageReactionThumbnail:"",
         messageDetails: '',
         notificationRead: false,
     },
    {
         profilePhoto: rizkyaAvatar,
         name: 'Jacob Thompson ',
         action: 'sent you a private message',
         isActionJoinLeftGroup: false,
         isActionReactToPost: false,
         isActionSentMessage: true,
         isActionReactToImage: false,
         groupName: '',
         postTitle: '',
         time: '1 day ago',
         imageReactionThumbnail:"",
         messageDetails: "Hello, thanks for setting up the Chess Club. I've been a member for a few weeks now and I'm already having lots of fun and improving my game.",
         notificationRead: true,
     },
     {
        profilePhoto: kimberlyAvatar,
        name: 'Kimberly Smith ',
        action: '  commented on your picture',
        isActionJoinLeftGroup: false,
        isActionReactToPost: false,
        isActionSentMessage: false,
        isActionReactToImage: true,
        groupName: '',
        postTitle: '',
        time: '1 week ago',
        imageReactionThumbnail:chessImage,
        messageDetails: '',
        notificationRead: true,
    },
    {
        profilePhoto: nathanAvatar,
        name: 'Nathan Peterson',
        action: 'reacted to your recent post',
        isActionJoinLeftGroup: false,
        isActionReactToPost: true,
        isActionSentMessage: false,
        isActionReactToImage: false,
        groupName: '',
        postTitle: ' 5 end-game strategies to increase your win rate',
        time: '2 weeks ago',
        imageReactionThumbnail:"",
        messageDetails: '',
        notificationRead: true,
    },
    {
         profilePhoto: annaAvatar,
         name: 'Anna Kim',
         action: 'has left your group',
         isActionJoinLeftGroup: true,
         isActionReactToPost: false,
         isActionSentMessage: false,
         isActionReactToImage: false,
         groupName: 'Chess Club',
         postTitle: '',
         time: '2 weeks ago',
         imageReactionThumbnail:"",
         messageDetails: '',
         notificationRead: true,
     },
 ]